
import BCXInfoCollapsible from '@/components/molecules/BCXInfoCollapsible.vue';
import BCXHelpTextTriggerIcon from '@/components/molecules/BCXHelpTextTriggerIcon.vue';
import BCXSearchSelect from '@/components/molecules/BCXSearchSelect.vue';
import useI18n from '@/mixins/useI18n';
import { SelectItem } from '@/models/SelectItem';
import { setGeneralSettings } from '@/services/Settings/Api';
import useSettings from '@/state/settingsState';
import {
  computed, defineComponent, ref, watch
} from 'vue';

type DisplayOption = 'YES' | 'NO';

export default defineComponent({
  name: 'ProfileDisplaySetting',
  components: {
    BCXInfoCollapsible,
    BCXHelpTextTriggerIcon,
    BCXSearchSelect,
  },
  setup() {
    const { t } = useI18n();
    const {
      settings, loadSettings, isSafeToAutoSave
    } = useSettings();

    const isHelpOpen = ref(false);
    const isLoading = ref(false);
    const list = computed<SelectItem[]>(() => ([
      {
        value: 'YES',
        text: `${t('settings.profile.display.options.YES')}`
      },
      {
        value: 'NO',
        text: `${t('settings.profile.display.options.NO')}`
      }
    ]));

    const initialValue = computed<DisplayOption>(() => (
      settings.value?.profileSettings?.displayExternal ? 'YES' : 'NO'
    ));
    const value = ref<DisplayOption>(initialValue.value);

    watch(initialValue, (nextValue) => {
      value.value = nextValue;
    });

    const save = async () => {
      if (!settings.value) return;

      isLoading.value = true;

      await setGeneralSettings({
        profileSettings: {
          displayExternal: value.value === 'YES'
        }
      });

      isLoading.value = false;
      await loadSettings();
    };

    const dirty = computed(() => isSafeToAutoSave.value && value.value !== initialValue.value);

    watch(dirty, async (isDirty) => {
      if (isDirty) {
        await save();
      }
    });

    return {
      isHelpOpen,
      isLoading,
      list,
      save,
      t,
      value
    };
  }
});
